<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column align="center" :label="getType(typ)">
        <el-table-column
          prop="rank"
          align="center"
          label="排名"
        />
        <el-table-column
          prop="num"
          align="center"
          :label="title"
          :formatter="scientificFormat"
        />
        <el-table-column
          prop="uid"
          align="center"
          label="玩家UID"
        >
          <template slot-scope="scope">
            <a href="javascript:;" style="color: #0e6cff;text-decoration:underline;text-underline: #1c84c6;" @click="gotoreward(scope.row.uid)"> {{ scope.row.uid }}</a>
          </template>
        </el-table-column>
        <el-table-column
          v-if="title !== '等级'"
          prop="level"
          align="center"
          label="等级"
        />

        <el-table-column
          prop="country"
          align="center"
          label="国家"
        />
        <el-table-column
          prop="price"
          align="center"
          label="累计充值"
          :formatter="scientificFormat"
        />
        <el-table-column
          prop="online"
          align="center"
          label="在线时长"
        >
          <template scope="scope">
            {{ convertTime(scope.row.online) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="reg_time"
          align="center"
          label="注册日期"
        />
        <el-table-column
          prop="log_time"
          align="center"
          label="登录日期"
        />
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { convertTime } from '@/utils'

export default {
  name: 'TableData',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: () => ''
    },
    typ: {
      type: Number,
      default: () => 1
    },
    pay: {
      type: Number,
      default: () => 0
    },
    ftyp: {
      type: String,
      default: () => 'levelId'
    }
  },
  methods: {
    convertTime,
    getType(type) {
      if (type === 1) {
        return '历史排行榜'
      }
      return '每日排行榜 (每小时刷新)'
    },
    scientificFormat(row, col, value) {
      if (value === 0) {
        return 0
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    gotoreward(uid) {
      const url = this.$router.resolve({ name: 'User', query: {
        uid: uid
      }}).href
      window.open(url, '_blank')
      // this.$router.push({ name: 'User', query: { uid: uid }})
    }
  }
}
</script>

<style scoped>

</style>
